import { render } from "./FormUpload.vue?vue&type=template&id=8d5c7df2&scoped=true"
import script from "./FormUpload.vue?vue&type=script&lang=js"
export * from "./FormUpload.vue?vue&type=script&lang=js"

import "./FormUpload.vue?vue&type=style&index=0&id=8d5c7df2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d5c7df2"]])

export default __exports__